import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router'

import { api } from '../api/client'
import type { FoodEntry, User } from '../api/types'
import EntryTable from '../components/EntryTable'

const UserEntries: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const [user, setUser] = useState<User | null>(null)
  const [entries, setEntries] = useState<FoodEntry[] | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!id) return
    setEntries(null)
    setUser(null)
    Promise.all([api.getUser(id), api.listEntries({ userId: id, limit: 200 })])
      .then(([u, r]) => {
        setUser(u)
        setEntries(r.items)
      })
      .catch((e: Error) => setError(e.message))
  }, [id])

  return (
    <section>
      <p className="mb-2 text-sm text-gray-500">
        <Link to="/users" className="hover:underline">
          ← All users
        </Link>
      </p>
      <h1 className="mb-1 text-2xl font-semibold">
        {user ? user.name ?? user.email : 'Loading…'}
      </h1>
      {user && (
        <p className="mb-4 text-sm text-gray-500">
          {user.email} · joined {new Date(user.createdAt).toLocaleDateString()}
        </p>
      )}
      {error && (
        <p className="mb-3 rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
          {error}
        </p>
      )}
      {entries === null ? (
        <p className="text-gray-500">Loading entries…</p>
      ) : (
        <EntryTable entries={entries} emptyMessage="This user has no entries." />
      )}
    </section>
  )
}

export default UserEntries
